import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import OrgSwitcher from '@/components/layout/OrgSwitcher';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Where a DTF Printer lands when its org runs no floor of its own (BLU-1335).
 * Chrome-free, one sentence and one action (PRODUCTION_DESIGN.md). The org
 * switcher collapses to a label for one org; for a second membership it is the
 * way out, since the stored active org would otherwise pin the person here. It
 * calls only `organization.getOrgLocationOptions`, which the role may call.
 */
export default function NoFloorScreen() {
  const { t } = useTranslation('auth');
  const { signOut } = useAuth();

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background p-6 text-center">
      <OrgSwitcher />
      <p className="max-w-xl text-2xl font-semibold">{t('noLocationAccess')}</p>
      <Button type="button" className="h-12 px-8 text-base" onClick={() => signOut()}>
        {t('signOut')}
      </Button>
    </main>
  );
}
